import Vue from 'vue'
import Router from 'vue-router'
import store from 'store'
import API from 'api'
import { app, clientEnv, common } from '@/utils'
export function routerSetup(routes) {
  Vue.use(Router)

  // 标记新进入页面
  let isNewRouter = true

  const router = new Router({
    base: '/wap/',
    mode: 'history',
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
  })

  const beforeSetup = async (to, from) => {
    app.setStatusBarColor('black')
    app.setPosterShareStatus(false)
    store.dispatch('setPageErrorState', { status: false })
    // 通知v消息内购当前页面是否是订单列表
    common.postInternally(to.name)
    if (to.meta.type === 'page') {
      // 设置页面title
      if (to.meta.title) {
        if (to.name !== 'refundApply') document.title = to.meta.title
      }
      // 如果是从其他网站进入的，则清空本地数据
      if (isNewRouter && document.referrer.indexOf(location.origin) === 0) {
        sessionStorage.removeItem('ref_url')
        sessionStorage.removeItem('last_url')
        sessionStorage.removeItem('recycle_last_url')
      }
      // 微信环境&&非商详页&&非小程序，显示
      if (
        clientEnv.default.isWx &&
        !(to.meta.showMenu && to.meta.showMenu == 'hide') &&
        !clientEnv.default.checkWeChat
      ) {
        store.dispatch('setShowMenu', true)
      } else {
        store.dispatch('setShowMenu', false)
      }
      // 深色模式是否自动反色判断
      if (to.meta.lightDark && to.meta.lightDark == 1 && clientEnv.default.isVivoApp) {
        var meta = document.createElement('meta')
        meta.name = 'color-scheme'
        meta.content = 'light dark'
        document.getElementsByTagName('head')[0].appendChild(meta)
      } else {
        var metaTags = document.getElementsByTagName('meta')
        for (var i = 0; i < metaTags.length; i++) {
          if (metaTags[i].getAttribute('name') == 'color-scheme') {
            metaTags[i].parentNode.removeChild(metaTags[i])
            break
          }
        }
        // 关闭公控深色模式，采用自动反色逻辑(商详页不关闭)
        if ((clientEnv.default.isIOS || clientEnv.default.isWx) && !(to.meta.lightDark && to.meta.lightDark == 1)) {
          document.documentElement.setAttribute('data-nx-theme', 'off')
        }
      }
      // 进入之前设置referUrl
      const refUrl = sessionStorage.getItem('ref_url')
      const lastUrl = sessionStorage.getItem('last_url')
      if (isNewRouter && refUrl == location.href) {
        store.dispatch('track/updateReferrer', lastUrl)
      } else {
        store.dispatch('track/updateReferrer', refUrl)
      }
      // 预加载模板不统计PV
      if (to.query.isTemplate) {
        return
      }
      // 更新埋点参数
      await store
        .dispatch('track/updateTrackData', {
          path: to.path,
          argStr: to.fullPath.split('?')[1],
          title: to.meta.title
        })
        .then(async () => {
          // 授权信息初始化成功之后才进行埋点上报
          if (!store.state.track.init) {
            await store.dispatch('track/initAuthInfo')
          }

          // 统计pv
          const temp = { is_done: 1, ...to.meta.stParams, ...store.state.track.params }
          API.log(temp)
          // 如果在app中，则调用app的上报
          if (temp.event_id) {
            const appTemp = { is_done: 1, ...to.meta.stParams, ...store.state.track.appParams }
            app.webDataReportByApp(appTemp)
          }
        })
    }
  }

  // 路由对应的组件被解析之前处理
  router.beforeEach((to, from, next) => {
    console.log('beforeEach')
    beforeSetup(to, from)
    next()
  })

  // 路由跳转完成后更新referrer
  router.afterEach((to, from) => {
    if (to.meta.type === 'page') {
      setTimeout(() => {
        const lastUrl = sessionStorage.getItem('last_url') || ''
        const refUrl = sessionStorage.getItem('ref_url') || ''
        if (isNewRouter && refUrl == location.href) {
          sessionStorage.setItem('last_url', lastUrl)
        } else {
          sessionStorage.setItem('last_url', refUrl)
        }
        sessionStorage.setItem('ref_url', location.href)
        isNewRouter = false
      })
    }
  })

  return router
}
